<template>
  <section class="not-found-view">
    <v-container>
      <v-card class="not-found-card" elevation="0">
        <p class="not-found-card__eyebrow">404 — Page not found</p>
        <h1>We could not find that Mayon page.</h1>
        <p>
          The page may have moved or the address may be incorrect. You can still find laboratory packages,
          diagnostic services, branch directions, and contact details using the links below.
        </p>
        <div class="not-found-card__links">
          <v-btn class="mayon-btn mayon-btn--primary" :to="{ name: 'home' }">Home</v-btn>
          <v-btn class="mayon-btn mayon-btn--secondary" :to="{ name: 'home', hash: '#services' }">Services</v-btn>
          <v-btn class="mayon-btn mayon-btn--secondary" :to="{ name: 'home', hash: '#packages' }">Packages</v-btn>
          <v-btn class="mayon-btn mayon-btn--ghost" :to="'/branches'">Branches</v-btn>
        </div>
      </v-card>
    </v-container>
  </section>
</template>

<script>
export default { name: 'NotFoundView' }
</script>

<style lang="scss" scoped>
.not-found-view { background: var(--mayon-bg); min-height: 70vh; padding: 7rem 0 5rem; }
.not-found-card { border: 1px solid var(--mayon-border) !important; border-radius: 28px !important; margin: 0 auto; max-width: 820px; padding: clamp(2rem, 5vw, 4rem); text-align: center; }
.not-found-card__eyebrow { color: var(--mayon-blue); font-weight: 900; letter-spacing: 0.08em; text-transform: uppercase; }
h1 { color: var(--mayon-navy); font-size: clamp(2.1rem, 5vw, 3.6rem); letter-spacing: -0.04em; line-height: 1.08; }
p { color: var(--mayon-muted); line-height: 1.75; }
.not-found-card__links { display: flex; flex-wrap: wrap; gap: 0.75rem; justify-content: center; margin: 2rem 0; }
</style>
